module.exports = __webpack_public_path__ + "img/20210610-IMG_07011.85fbff7e.jpg";